import { Component } from "react";

export default class ResettableErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ResettableErrorBoundary] caught", error, info);
  }

  handleReset = () => {
    try {
      localStorage.clear();
    } catch {
      /* ignore */
    }
    try {
      sessionStorage.clear();
    } catch {
      /* ignore */
    }
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 px-6 py-10 text-slate-200">
          <div className="w-full max-w-xl rounded-2xl border border-rose-500/20 bg-rose-500/[0.06] p-5">
            <p className="text-xs font-semibold uppercase tracking-widest text-rose-200/90">App error</p>
            <p className="mt-2 text-sm text-slate-300">
              The Command interface crashed while rendering. You can reset the app to clear stored state and reload.
            </p>
            <button
              type="button"
              onClick={this.handleReset}
              className="mt-4 w-full rounded-lg bg-rose-400 px-4 py-2 text-sm font-bold text-[#050810] hover:bg-rose-300"
            >
              Reset App
            </button>
            <p className="mt-3 text-[10px] text-slate-500">
              This clears <code className="rounded bg-white/5 px-1">localStorage</code> /{" "}
              <code className="rounded bg-white/5 px-1">sessionStorage</code> and reloads the page.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

